export default __webpack_public_path__ + "static/media/corona.18b5f53c.gif";